<template>
  <!-- 改了 -->
  <div class="main" :class="show ? 'h5main' : ''">
    <div class="htop">
      <mtop id="ts-top" />
    </div>
    <div class="banner">
      <div class="banimg">
        <div class="title">新闻资讯</div>
        <div class="tip">
          最新新闻热点，实时呈现
        </div>
<!--        <div class="btn-box">-->
<!--          <div class="btn" @click="dialogVisible = true, clickMenu('免费试用')">立即咨询</div>-->
<!--        </div>-->
      </div>
    </div>
    <!-- <div class="abg-radio" id="top-btns">
      <div class="abg-nav" v-for="(item, index) in jqNewsBtns" :key="item.id" :class="{ active: current2 == index }"
        @click="current2 = index, getList(), getHotList()">
        {{ item.name }}
      </div>
    </div> -->
    <div class="main_box">
      <!-- <div class="slideshow">
        <van-swipe
          class="my-swipe"
          :options="swiperOption"
          :show-indicators="false"
          ref="news"
        >
          <van-swipe-item v-for="(item,i) in list" :key="i" >
            <div class="item" >
              <img :src="item.thumb" alt="" srcset="" />
              <div class="title">{{item.title}}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <div class="pre" @click="pre"></div>
        <div class="next" @click="next"></div>
      </div> -->
      <!-- <div class="box_top">
        <div
          class="left_item"
          :class="firstIndex == item.id ? 'show' : ''"
          @click="clickNav(item.id, index)"
          v-for="(item, index) in navtitle"
          :key="index"
        >
          <div class="l_title">{{ item.name }}</div>
        </div>
      </div> -->
      <div class="box_right" v-if="list.length > 0">
        <div class="right_item" v-for="(item, index) in list" :key="index" @click="toPage(item)">
          <div class="item_img">
            <img :src="item.coverImgUrl" alt="" />
          </div>
          <div class="item_con">
            <div class="con1">{{ item.name }}</div>
            <div class="con2">{{ item.description }}</div>
            <!-- <div class="con3">
              <div class="con3_tab" v-for="(items, i) in item.label" :key="i">
                {{ items }}
              </div>
            </div> -->
            <div class="con4">
              <img src="../assets/sdImages/news/Frame 17@2x.png" alt="" />
              {{ item.createTime }}
            </div>
            <!-- <div class="btn" @click="toPage(item)">查看详情</div> -->
          </div>
        </div>

        <el-pagination v-show="listQuery.total > 1" :page-size.sync="listQuery.page_size"
          :current-page.sync="listQuery.page" @pagination="getList" :background="!show" class="page"
          layout="prev, pager, next" @current-change="handleCurrentChange" :total="listQuery.total">
        </el-pagination>
      </div>
      <div class="box_right" v-else>
        <van-empty description="暂无更多信息~" />
      </div>
      <div class="box_left" id="right-news-wrap">
        <div class="cards">
          <div class="img">
            <img src="../assets/sdImages/news/wenzhang 1@2x.png" alt="" srcset="" />
            <div class="title">热门文章</div>
            <!-- <div class="more">
              <span class="more-text">更多</span><span>></span>
            </div> -->
          </div>
          <template v-if="hotList.length > 0">
            <div class="conttxt" v-for="(item, index) in hotList" :key="index"  @click="toPage(item)">
              <div class="dot"></div>
              <div class="text">{{ item.name }}</div>
            </div>
          </template>
          <div class="box_right" v-else>
            <van-empty description="暂无更多信息~" />
          </div>
        </div>
        <div class="cards tsCards">
          <div class="img">
            <img src="../assets/sdImages/news/ganhuo 1@2x.png" alt="" srcset="" />
            <div class="title">更多资讯信息</div>
          </div>
          <div class="conttxt conttxtdd">
            <div class="code"></div>
            扫码获取更多资讯 <br />公众号：善达信息
          </div>
        </div>
      </div>
    </div>

    <mbottom />

    <!-- 提交成功的弹窗 -->
    <!-- <van-popup v-model="showlist" round :close-on-click-overlay="false">
         <div :class="show==false?'popup':'popuph5'">
            <div class="img">
               <img src="../assets/image/correct.png" alt="">
            </div>
            <div class="con">信息提交成功，我们正快马加鞭的处理中~</div>
            <div class="bottom">
               <div @click="backBtn">返回</div>
            </div>
         </div>
      </van-popup> -->
      <demonstrate
      :dialogVisible="dialogVisible"
      @closeDialog="closeDialog"
    ></demonstrate>
  </div>
</template>

<script>
import { connectTron } from "@/api/Public";
import mtop from "../components/top.vue";
import mbottom from "../components/bottom.vue";
import { staClickMenu } from "../utils/index";
import demonstrate from "../components/demonstrate.vue";
export default {
  data() {
    return {
      listQuery: {
        page: 1,
        page_size: 5,
        total: 0,
        type: 2, //新闻
      },
      opacityval: 0,
      backgroundurl:
        "https://www.xingrunkeji.cn//storage/uploads/20220228/b2b35a5f2f920c6a2b3f919da64317d4.png",
      ploblem: {
        id: 1,
        name: "常见问题",
        english: "problem",
        back_img:
          "https://www.xingrunkeji.cn//storage/uploads/20220228/b2b35a5f2f920c6a2b3f919da64317d4.png",
        status: 2,
        sort: 4,
        update_time: "2022-02-25 15:52:18",
        create_time: "2021-08-13 17:55:32",
      },
      navtitle: [],
      firstIndex: 1,
      show: false,
      showlist: false, //提交成功的弹窗
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      list: [],
      swiperOption: {
        //循环  实现无限切换
        loop: true,
        navigation: {
          //下一张
          nextEl: ".next", //下一张标签类名可以自定义
          //上一张
          prevEl: ".pre", //上一张标签类名可以自定义
        },
      },
      current2: 0,
      jqNewsBtns: [
        { id: "1", name: "公司新闻" },
        { id: "2", name: "行业动态" },
        { id: "3", name: "技术学堂" },
      ],
      hotList: [],
      dialogVisible:false
    };
  },

  components: {
    mtop,
    mbottom,
    demonstrate
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    if (this._isMobile()) {
      this.show = true;
    } else {
      this.show = this.$store.getters.phone;
    }

    // this.getInfo();
  },
  beforeDestroy() {
    // 移除滚动事件监听器
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    "$store.getters.conid": function (val) {
      sessionStorage.setItem("conid", val);
    },
    "$store.getters.phone": function (val) {
      this.show = val;
    },
    "$route.query.current": function (val) {
      this.current2 = val;
      this.getList();
      this.getHotList()
    },
    deep: true,
    immediate: true,
  },
  created() {
    this.current2 = this.$route.query.current||0;
    this.getList();
    this.getHotList()
  },
  methods: {
    // 统计菜单点击
    clickMenu(menuName, url) {
      if (url) {
        this.$router.replace({
          path: url,
        });
      } else {
        if (menuName != '免费试用') {
          this.$toast("敬请期待");
        }
      }
      staClickMenu(menuName)
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    handleScroll() {
      //滚动头部背景变色
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      console.log("scrollTop---->", scrollTop);

      if (scrollTop >= 620) {
        // document.getElementById('right-news-wrap').style = 'position:fixed;top:0px;right: 300px'
        // document.getElementById("top-btns").style =
        //   "z-index:999;position:fixed;top:0;background: #ffffff;border: 1px solid hsla(0, 0%, 100%, .2);box-shadow: 0 8px 32px rgba(28, 67, 125, .06);";
      }

      if (scrollTop < 620) {
        // document.getElementById('right-news-wrap').style = ''
        // document.getElementById("top-btns").style =
        //   "position:static;top:0;border: none;box-shadow: none;";
      }
    },
    next(e) {
      this.$refs.news.next(e);
    },
    pre(e) {
      this.$refs.news.prev(e);
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    getInfo() {
      this.$axios({
        method: "get",
        url: "/v1/cateList",
      })
        .then((res) => {
          this.navtitle = res.data.data.list;
          this.navtitle.unshift(this.ploblem);
        })
        .catch(() => {
          console.log("请求失败");
        });
    },
    clickNav(e) {
      if (this.firstIndex == e) {
        return false;
      } else {
        this.firstIndex = e;
        this.listQuery.cate_id = e;
        this.getList();
      }
    },
    toPage(row) {
      sessionStorage.setItem("conid", row.id);
      // let nextId = '';
      // let nextName = '';
      // let indexx = 0;
      // for (let i in this.list) {
      //   if (this.list[i].id == row.id) {
      //     indexx = Number(i)
      //   }
      // }
      // if (indexx + 1 >= Number(this.list.length)) {
      //   nextId = ''
      //   nextName = ''
      // } else {
      //   nextId = this.list[indexx + 1].id
      //   nextName = this.list[indexx + 1].name
      // }

      this.$router.push({
        path: "teamdetal",
        query: {
          detail: row.id,
        },
      });
    },
    backBtn() {
      //点击返回取消弹框
      this.showlist = false;
    },
    wallet() {
      var i = 0;
      var a = setInterval(() => {
        if (typeof window.ethereum !== "undefined") {
          connectTron().then(
            (info) => {
              clearInterval(a);
              if (info[0].indexOf("0x") == 0) {
                if (info[0] != this.$store.getters.userWallet) {
                  this.buy = true;
                }
                this.$store.commit("userWallet", info[0]);
              } else {
                this.$toast("Use the ETH address to log in to the game");
              }
            },
            (e) => {
              this.$toast(e.message);
            }
          );
        }
        if (i > 5) {
          clearInterval(a);
        }
        i++;
      }, 1000);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pod|iPhone|iPod|ios|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    topage(e) {
      this.$router.replace({ path: e });
      this.$store.commit("sid", "");
    },
    tobuy() {
      location.href = "https://opensea.io/collection/cupid-love-metaverse";
    },
    up() {
      if (this.sqloading) {
        return;
      }
      this.buynum = Number(this.buynum) + 1;
    },
    dow() {
      if (this.sqloading) {
        return;
      }
      this.buynum = this.buynum <= 1 ? 1 : Number(this.buynum) - 1;
    },
    close() {
      this.shows = false;
    },
    handleFiexdToolItem(e) {
      if (!e) {
        return;
      }
      this.$nextTick(() => {
        document.getElementById(e).scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      });
    },
    // 获取热门文章
    async getHotList() {
      let res = await this.$http.post(this.$api.listArticle, {
        current: 1,
        size: 5,
        typeId: `1,${Number(this.current2) + 2}`,
        status: '1'
      });
      this.hotList = res.data.data.records
    },
    // 获取列表数据
    async getList() {
      let res = await this.$http.post(this.$api.listArticle, {
        current: this.listQuery.page,
        size: this.listQuery.page_size,
        typeId: `1,${Number(this.current2) + 2}`,
        status: '1',
      });
      this.list = res.data.data.records
      localStorage.removeItem('newsListdd')
      localStorage.setItem("newsListdd", JSON.stringify(this.list));
      this.listQuery.total = res.data.data.total
      // console.log('res---dddd-->', res.data.data)
      return
      this.list = [
        {
          "id": 16,
          "title": "域名备案都需要提交哪些资料？",
          "thumb": "https://www.xingrunkeji.cn//storage/uploads/20220307/b2e2f97e83fd344c8335f78911610fff.webp",
          "content": "<p>---------------------企业备案---------------------</p>\n<p>1，企业营业执照扫描件</p>\n<p>2，企业负责人身份证扫描件</p>\n<p>3，企业负责人授权书（如负责人不是企业法人）扫描件</p>\n<p>4，信息安全协议书扫描件(需盖公章)</p>\n<p>5，真实性核验单扫描件（需盖公章）</p>\n<p>6，负责人现场照片扫描件</p>\n<p>7，域名证书扫描件</p>\n<p>&nbsp;</p>\n<p>---------------------个人备案---------------------</p>\n<p>1，网站负责人身份证扫描件</p>\n<p>3，负责人授权书（如网站负责人不是域名所有人）扫描件</p>\n<p>4，信息安全协议书扫描件(需签字)</p>\n<p>5，真实性核验单扫描件（需签字）</p>\n<p>6，负责人现场照片扫描件</p>\n<p>7，域名证书扫描件</p>",
          "label": [
            "备案"
          ],
          "author": "星润科技",
          "description": "网站备案是对域名拥有者的保护，域名备案的目的就是为了防止在网上从事非法的网站经营活动,打击不良互联网信息的传播,如果网站不备案的话,很有可能被查处以后关停",
          "click": 419,
          "create_time": "2022-03-07 16:24:05",
          "is_hot": 2
        },
        {
          "id": 19,
          "title": "企业如何接轨web3.0时代？",
          "thumb": "https://www.xingrunkeji.cn//storage/uploads/20221226/ed5cbd57bc3231a72e1e4fdccffa08f9.png",
          "content": "<p>NFT是元宇宙的底层基建，在web3.0还未成熟时，各大应用场景还未开发成熟应用前，发行自己的品牌nft数字藏品，打造专属于自己的元宇宙nft平台，是快速进入元宇宙的方式，同时通过稀台saas系统的不断更新可以一直享受元宇宙不断发展的市场红利和最新的技术形式。</p>",
          "label": [
            "软件资讯",
            "定制开发",
            "互联网"
          ],
          "author": "",
          "description": "NFT是元宇宙的底层基建，在web3.0还未成熟时，各大应用场景还未开发成熟应用前，发行自己的品牌nft数字藏品，打造专属于自己的元宇宙nft平台，是快速进入元宇宙的方式，同时通过稀台saas系统的不断更新可以一直享受元宇宙不断发展的市场红利和最新的技术形式。",
          "click": 47,
          "create_time": "2022-12-26 10:24:07",
          "is_hot": 1
        },
        {
          "id": 18,
          "title": "如何选择一个专业的开发公司?",
          "thumb": "https://www.xingrunkeji.cn//storage/uploads/20220308/33b9448b9c37aefebc148bf2dc910259.jpg",
          "content": "<p>1、成立多年的公司<br />如果需要开发比较重要的网站或应用，您应该选择登记有案的开发公司，因为他们能撑过10年以上绝对有它的市场，这些公司可以陪着您的网站一起成长，成为最佳伙伴。</p>\n<p>2、衷于自己的喜好<br />第一眼的喜欢真的很重要，如果您真心喜欢这家网站建设公司，就不需要用太多的理由去说服自己接受，未来在网站建设进行沟通的时候会比较顺利，别勉强选择不喜欢的设计公司，因为最终只会陷入恶性循环之中。</p>\n<p>3、专注网站建设的公司<br />什么是专注在网站建设的公司?简单来说就是公司以「网站建设」作为主轴的设计公司，没有平面设计，没有品牌设计，没有产品设计，没有影片设计。为什么要找这样的网站建设公司?因为网站建设是一个很专业的工作，通常需要专业的分工才能达成，专业的网站建设公司从接洽开始就是一连串的专业，从网站规划、视觉设计、前端设计、后端设计、系统工程、网站维护、网站行销. .等，每个环节紧紧相连，缺一不可，很多设计公司规模较小，没办法聘用这么多专业的人，只好外包给外面的公司，造成设计品质低落，甚至不负责任的状况，有些设计公司不是规模小，而是规模大项目多，主轴不是网站建设，而是以「品牌规划」作为主轴，所以把「网站建设」工作外包出去，这时候的网站没有经过专业的洗礼，就会产生「只有好看却很难用」的网站，所以找专注在网站建设的公司就变得非常重要了，专业团队就是一群专家组成的。</p>\n<p>&nbsp;</p>",
          "label": [
            "网站定制",
            "软件开发"
          ],
          "author": "星润科技",
          "description": "如果需要开发比较重要的网站或应用，您应该选择登记有案的开发公司，因为他们能撑过10年以上绝对有它的市场，这些公司可以陪着您的网站一起成长，成为最佳伙伴。",
          "click": 320,
          "create_time": "2022-03-08 19:16:37",
          "is_hot": 2
        },
        {
          "id": 15,
          "title": "哪些网站不适合做百度推广 哪些网站不适合做百度推广？",
          "thumb": "https://www.xingrunkeji.cn//storage/uploads/20220303/d5d02b4b46d47bd573f582a7708ed14b.jpg",
          "content": "<p>1、针对国内业务，但是网站设计有中英文切换的</p>\n<p>中文网站就好，增添一个英文板块对推广没有用，并不会显得更加高大上，反而会分散访客的注意力，增加访客找到产品或服务的时间。</p>\n<p>2、flash动画声先夺人</p>\n<p>记住，访客来网站是来找自己想要的产品或者服务的，不是来看动画节目的。动画除了影响网页打开速度，还会增加访客进主页的时间，3秒钟还没有看到自己想看到的内容，大多数访客就会离开。</p>\n<p>3、单页网站，但是页面太长</p>\n<p>一本书，你希望它只有1页，但是长10米，还是希望这本书是100页，每一页的长度是10厘米?设计网站，应当像设计编排一本书一样，做出适合阅读的，令人舒适的网页。</p>\n<p>4、沟通工具太多</p>\n<p>有的客户的网站上放了53客服的代码，百度商桥，还有营销qq，到处都是沟通窗口。一个普通客户来到网站，由于过多的选择，会让他无所适从，而变得烦躁。用一个工具就够了，有营销qq的，首选营销qq，其次是百度商桥。推荐放置在网站右侧，访客进入网站后，会很自然的将鼠标指针拉到右侧浏览网页，这样沟通更加自然。</p>\n<p>以上就是对&ldquo;哪些网站不适合做百度推广？&rdquo;的相关介绍，如果企业想通过百度营销带来更多客户，您可以在下方免费注册百度营销了解更多。</p>",
          "label": [
            "软件资讯",
            "定制开发",
            "互联网"
          ],
          "author": "星润科技",
          "description": "什么样的网站不适合做推广？在竞价推广的过程中，很多人忽略了网",
          "click": 310,
          "create_time": "2022-03-03 14:00:53",
          "is_hot": 2
        },
        {
          "id": 14,
          "title": "什么是区块链商城，有什么价值？",
          "thumb": "https://www.xingrunkeji.cn//storage/uploads/20220303/a608a16a2f7749a5a49d59962905d627.png",
          "content": "<p>区块链商城就是是基于区块链技术开发的商城购物平台。<br />商城结合区块链技术打破传统的零售模式，打破传统的电商模式，商城运用大数据，最终要通过个人和商家，打造全新的&ldquo;去中心化&rdquo;的消费数据交易体系，它将比现有的中心化数据体系更灵活、更低成！</p>\n<p><img class=\"wscnph\" src=\"https://www.xingrunkeji.cn//storage/uploads/20220303/70add18e56124298a1227a8989a396a6.png\" /></p>\n<p>区块链商城系统的模式<br /><br />区块&zwnj;&zwnj;链商城系统的模式就是&ldquo;工具+社群+电商微商&rdquo;的混合模式。<br /><br />先是通过各自工具属性社交属性价值内容的核心功能过滤到海量的目标用户后，加入了朋友圈点赞与评论等社区功能，继而添加了微信支付、精选商品、电影票、手机话费充值等商业功能。<br /><br />为什么会出现这种情况呢？简单地说，这些工具能够满足用户的痛点需求，用来做流量的人口，但它们无法有效沉淀粉丝用户。<br /><br />社群是关系属性，用来沉淀流量;商业是交易属性，用来变现流量价值。两者看上去不相关，但内在融合的逻辑是一体化的。</p>\n<p>&nbsp;</p>\n<p>区块链商城系统有什么价值？<br /><br />1、系统的应用为商家多搭建了一个营销渠道，在现在企业的营销模式中，对于微信营销不只是停留在做还不不做的问题上，而是做的快与慢，质量好坏的问题，在同行业竞争中，对手已经定制开发出了自己的区块链时，并配合完整的微信营销方案推广时，就已经在抢夺您的市场，如果还未加入区块链就少了一个用户导入、绿方优选销售转化的途径。</p>\n<p>2、客户留存工具，微网站，代理商，微会员卡已经能够让你的客户成为忠实客户，当你的客户累计1万人时。你发个促销或者打折优惠信息就能有1万人看到。相对于传统的商城大街派发传单，成本费用高、效果不明显，数据分析无基础依据，&ldquo;区块链商城系统&rdquo;就可以对活动成本的控制，并对活动后期数据进行详细分析。<br /><br />3、让粉丝变现工具，假如你的个人微信粉丝上万或者更多，如果没有使用区块链系统，就没有办法让粉丝发生购买行为，就没有办实现粉丝的变现。<br /><br />4、用户基础大，流量转化高，微信已拥有7亿用户，未来或许更多，俗话说有流量的地方就有江湖，有人的地方就有买卖;在面对如此巨大的用户基础时，企业应当抓住微信带来商机，使用赢在移动区块链商城系统对用户进行精准营销，以微信为流量导入口，提高转化率。<br /><br />区块链商城系统有什么好处?<br /><br />现在的大多行业都利用区块链技术作为基底打造管理系统、商城系统。<br /><br />据业内人员表示，微信最开始就是一种社交工具，区块链商城系统先是通过各自工具属性社交属性价值内容的核心功能过滤到海量的目标用户后，继而添加了微信支付、精选商品、电影票、手机话费充值等商业功能。<br /><br />所以说微信也是让用户在使用微信时得到了更好地生活体验，进而才会吸引新的用户加入其中。<br /><br />开发的区块链商城系统能够帮助商家打通供货商，直接链接推广员与消费者，让产品在短时间内得到传播，在移动裂变中获取更多的商业价值，推动圈内商品流通，促进商业发展和赢得消费者的信赖</p>",
          "label": [
            "软件资讯",
            "定制开发",
            "互联网"
          ],
          "author": "作者",
          "description": "区块链商城就是是基于区块链技术开发的商城购物平台。商城结合区块链技术打破传统的零售模式，打破传统的电商模式，商城运用大数据，最终要通过个人和商家，打造全新的“去中心化”的消费数据交易体系，它将比现有的中心化数据体系更灵活、更低成！区块链商城系统的模式区块‌‌链商城系统的模式就是“工具+社群+电商微商",
          "click": 335,
          "create_time": "2022-03-03 10:30:55",
          "is_hot": 1
        }
      ]
    },
  },
};
</script>
<style lang="scss" scoped>
$t-mf: "Arial";

.main {
  background: #fff;
  max-width: 100%;
  min-width: 1360px;
  width: 100%;

  .htop {
    height: 64px;

    #ts-top {
      position: relative;
    }
  }

  // .banner {
  //   width: 100%;
  //   font-size: 0;
  //   .simg {
  //     width: 100%;
  //     height: auto;
  //   }
  // }
  .banner {
    max-width: 100%;
    min-width: 1200px;
    width: 100%;
    // margin-bottom: 19px;

    .banimg {
      max-width: 100%;
      min-width: 1200px;
      width: 100%;
      height: 550px;
      position: relative;
      text-align: left;
      background: url(~@/assets/sdImages/news/Maskgroupnew.png) no-repeat;
      // background-size: 100% 100%;
      background-size: cover;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .title {
        width: 1200px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 36px;
        color: #333333;
        font-style: normal;
        text-transform: none;
      }

      .tip {
        width: 1200px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        font-style: normal;
        text-transform: none;
        margin-top: 13px;
      }

      .btn-box {
        width: 1200px;
        margin-top: 32px;

        .btn {
          width: 128px;
          height: 48px;
          background: #1664ff;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          font-style: normal;
          text-transform: none;
          padding: 9px 0;
          box-sizing: border-box;
        }

        .btn:hover {
          opacity: 0.9;
        }
      }
    }
  }

  .abg-radio {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 77px;
    box-sizing: border-box;

    .abg-nav {
      // border: 1px solid #e8e9ea;
      height: 77px;
      margin-right: 23px;
      padding: 0 45px;
      // font-family: PingFang SC, PingFang SC;
      line-height: 77px;
      font-weight: 500;
      font-size: 18px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      cursor: pointer;
      box-sizing: border-box;
    }

    .active {
      background: #3a89fe;
      // font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 18px;
      color: #ffffff;
      font-style: normal;
      text-transform: none;
      height: 77px;
      line-height: 77px;
    }
  }

  .box1_top {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    text-align: left;
    font-size: 14px;
    // font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 50px;

    align-items: center;

    .img {
      width: 24px;
      height: 24px;
      // background: url("../assets/indeximg/point.png");
      background-size: 100% 100%;
      margin-right: 12px;
    }

    div>span {
      color: #0052da;
      cursor: pointer;
    }
  }

  .main_box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
    margin-top: 70px;
    // flex-direction: column;
    background: #ffffff;

    .slideshow {
      width: 100%;
      height: 400px;
      margin: 24px 0 0;
      position: relative;

      .pre {
        // background: url("../assets/ximg/icon-zuo.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 100;
      }

      .next {
        // background: url("../assets/ximg/icon-you.png") no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
        position: absolute;
        left: calc(100% - 46px);
        top: 50%;
        transform: translateY(-50%);
        z-index: 100;
      }

      .my-swipe {
        width: 1200px;
        height: 400px;
        position: relative;
      }

      .item {
        position: relative;
        width: 1200px;
        height: 400px;
        font-size: 0;

        img {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
        }

        .title {
          background: rgba(0, 0, 0, 0.6);
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          height: 81px;
          line-height: 81px;
          font-size: 24px;
          // font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          padding-left: 33px;
          text-align: left;
          box-sizing: border-box;
        }
      }
    }

    .box_top {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
      width: 100%;

      .left_item {
        min-width: 64px;
        height: 57px;
        box-sizing: border-box;
        padding: 14px 0;
        margin: 25px;
        cursor: pointer;
        position: relative;

        .l_title {
          font-size: 16px;
          // font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #1d2129;
        }

        .l_titleen {
          font-size: 16px;
          // font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fff;
        }
      }

      .imgbg {
        position: absolute;
        top: 0;
        left: 0;
        width: 240px;
        height: 77px;
        opacity: 0;
        transition: all 0.5s;

        // transform: 0.3;
      }

      .show,
      .left_item:hover {
        border-bottom: 1px solid #2b6bff;
      }

      // .left_item:hover{
      //    background: #0052DA;
      //    div{
      //       color: #fff !important;
      //    }
      // }
      // .itemact1:hover{
      //    background:url('../assets/indeximg/leftimg/p1.png');
      //    background-size: 100% 100%;
      // }
      //  .itemact2:hover{
      //    background:url('../assets/indeximg/leftimg/p2.png');
      //    background-size: 100% 100%;
      // }
      // .itemact3:hover{
      //    background:url('../assets/indeximg/leftimg/p3.png');
      //    background-size: 100% 100%;
      // }
      // .itemact4:hover{
      //    background:url('../assets/indeximg/leftimg/p4.png');
      //    background-size: 100% 100%;
      // }
      //   .itemact1 {
      //     background:url('../assets/indeximg/leftimg/p1.png');
      //    background-size: 100% 100%;
      //    div {
      //       color: #fff !important;
      //    }
      // }
      //   .itemact2 {
      //    background:url('../assets/indeximg/leftimg/p2.png');
      //    background-size: 100% 100%;
      //    div {
      //       color: #fff !important;
      //    }
      // }
      //  .itemact3 {
      //    background:url('../assets/indeximg/leftimg/p3.png');
      //    background-size: 100% 100%;
      //    div {
      //       color: #fff !important;
      //    }
      // }
      //  .itemact4 {
      //   background:url('../assets/indeximg/leftimg/p4.png');
      //    background-size: 100% 100%;
      //    div {
      //       color: #fff !important;
      //    }
      // }
      //  .itemact2 {
      //    background:url('../assets/indeximg/leftimg/p2.png');
      //    background-size: 100% 100%;
      //    div {
      //       color: #fff !important;
      //    }
      // }
      .itemact {
        // background:url('../assets/indeximg/leftimg/p1.png');
        // background-size: 100% 100%;
        // div{
        //    color: #fff !important;
        // }
      }
    }

    .box_right {
      width: 100%;
      // background: #f7f8fa;
      box-sizing: border-box;
      padding: 0 28px 32px 28px;
      display: flex;
      flex-direction: column;

      .right_item {
        display: flex;
        justify-content: space-between;
        // border-bottom: 1px solid #eee;
        // height: 160px;
        align-items: center;
        margin-bottom: 72px;

        .item_img {
          width: 275px;
          height: 117px;
          flex-shrink: 0;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            transition: 0.35s;
            object-fit: cover;
          }
        }

        .item_img img:hover {
          transform: scale(1.1);
        }

        .item_con {
          width: 100%;
          // height: 180px;
          display: flex;
          flex-direction: column;
          text-align: left;
          margin-left: 17px;
          justify-content: center;
          // justify-content: space-between;
          cursor: default;
          position: relative;

          .con1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #1e1e21;
            line-height: 30px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 7px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            overflow: hidden;
          }

          .con1:hover {
            color: #3a89fe;
          }

          .con2 {
            font-family: PingFang SC, PingFang SC;
            // width: 509px;
            font-weight: 500;
            font-size: 14px;
            color: #8d8f94;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            margin-bottom: 19px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .con3 {
            display: flex;
            margin-top: 30px;

            .con3_tab {
              width: 56px;
              height: 22px;
              border: 1px solid #dadada;
              border-radius: 2px;
              text-align: center;
              margin-right: 5px;
              line-height: 22px;
              font-size: 10px;
              // font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              cursor: default;
            }
          }

          .con4 {
            cursor: default;
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #8d8f94;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            display: flex;
            align-items: center;

            img {
              width: 13px;
              height: 13px;
              margin-right: 5px;
            }
          }

          .btn {
            width: 112px;
            height: 40px;
            border-radius: 2px;
            border: 1px solid #2b6bff;
            font-size: 16px;
            // font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #2b6bff;
            line-height: 24px;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            right: 30px;
            bottom: 0px;
            cursor: pointer;
          }
        }
      }

      // .item_con:hover {
      //   background: linear-gradient(0deg, #eee 0%, #fff 100%);
      // }
    }

    .box_left {
      width: 360px;
      flex-shrink: 0;
      background-color: #fff;

      .tsCards {
        height: 183px !important;
      }

      .cards {
        width: 100%;
        height: 384px;
        border: 1px solid #e3eaf3;
        padding: 20px 28px 20px 24px;
        box-sizing: border-box;
        margin-bottom: 14px;

        .img {
          display: flex;
          align-items: center;
          padding-bottom: 12px;
          border-bottom: 1px solid #e4e6f0;

          img {
            width: 24px;
            height: 24px;
          }

          .title {
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #333333;
            font-style: normal;
            text-transform: none;
            margin-left: 12px;
            width: 228px;
          }

          .more {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 15px;
            color: #282b42;
            font-style: normal;
            text-transform: none;
            cursor: pointer;

            .more-text {
              margin-right: 1px;
            }
          }
        }
        .conttxtdd {
          padding-top: 10px !important;
        }
        .conttxt {
          padding-top: 20px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 15px;
          color: #1e1e21;
          line-height: 26px;
          text-align: left;
          font-style: normal;
          text-transform: none;
          display: flex;
          align-items: center;
          cursor: pointer;

          .dot {
            background: #282b42;
            border-radius: 100%;
            width: 6px;
            height: 6px;
            margin-right: 10px;
            flex-shrink: 0;
          }

          .text {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          .code {
            width: 107px;
            height: 108px;
            background: url(~@/assets/sdImages/code/gzh.png) no-repeat;
            background-size: 100% 100%;
            margin-right: 10px;
            flex-shrink: 0;
          }
        }

        .conttxt:hover {
          color: #3a89fe;
        }
      }
    }
  }
}

.mainh5 {
  width: 100%;
  max-width: 750px;
  min-height: 100vh;

  .popuph5 {
    box-sizing: border-box;
    padding: 34px;
    width: 666px;
    height: 307px;
    background: #ffffff;
    border-radius: 35px;

    .img {
      width: 82px;
      height: 58px;
      margin: 0 auto;
    }

    .con {
      font-size: 20px;
      // font-family: PingFang SC;
      font-weight: bold;
      color: #333649;
      line-height: 30px;
      margin-bottom: 60px;
      margin-top: 40px;
    }

    .bottom {
      div {
        width: 104px;
        height: 41px;
        background: #3051e8;
        box-shadow: 0px 4px 20px 0px rgba(16, 51, 213, 0.29);
        border-radius: 20px;
        font-size: 18px;
        // font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 41px;
        margin: 0 auto;
      }
    }
  }

  .bannerh5 {
    max-width: 750px;
    min-width: 640px;
    width: 100%;

    .ban_title {
      width: 210px;
      font-size: 35px;
      // font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 81px;
      display: flex;
      justify-content: center;
    }

    .inpbox {
      display: flex;
      justify-content: left;
      position: absolute;
      width: 470px;
      height: 53px;
      background: #ffffff;
      border-radius: 27px;
      top: 219px;
      //
      left: 50%;
      margin-left: -235px;

      input {
        border: none;
        outline: none;
        width: 390px;
        padding-left: 40px;
        background: rgba(255, 255, 255, 0);
      }
    }

    .help_box {
      width: 100%;
      min-height: 1983px;
      background: #ffffff;
      box-shadow: 0px 1px 118px 8px rgba(48, 81, 232, 0.1);
      z-index: 1;
      box-sizing: border-box;
      padding: 30px 40px;

      .box_title {
        font-size: 40px;
        // font-family: PingFang SC;
        font-weight: 800;
        color: #333649;
        line-height: 81px;
        text-align: center;
        margin-bottom: 34px;

        span {
          color: #4661e9;
        }
      }

      .box_title2 {
        text-align: left;
        font-size: 26px;
        // font-family: PingFang SC;
        font-weight: 500;
        color: #333649;
        line-height: 40px;
      }

      .form_box {
        margin-top: 94px;

        .form_item {
          .item_title {
            text-align: left;
            font-size: 20px;
            // font-family: PingFang SC;
            font-weight: bold;
            color: #333649;
            line-height: 30px;
          }

          .exm {
            font-size: 14px;
            // font-family: PingFang SC;
            font-weight: bold;
            color: #9295a9;
            line-height: 30px;
            text-align: left;
          }

          .inp {
            margin-top: 14px;

            .check_box {
              display: flex;
              flex-direction: column;
              text-align: left;
              font-size: 16px;
              // font-family: PingFang SC;
              font-weight: 500;
              color: #333649;
              // line-height: 18px;
              // justify-content:left;
              // align-content: left;
            }
          }
        }

        .sub_btn {
          width: 191px;
          height: 39px;
          line-height: 39px;
          background: #3051e8;
          border-radius: 20px;
          font-size: 18px;
          // font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding: 0;
        }
      }

      .form_boxh5 {
        margin-top: 94px;

        width: 100%;
        min-width: 640px;
        max-width: 750px;
        margin-left: 0px;
        padding-left: 0px;

        .form_item {
          width: 100%;

          .item_title {
            text-align: left;
            font-size: 26px;
            // font-family: PingFang SC;
            font-weight: bold;
            color: #333649;
            line-height: 30px;
          }

          .exm {
            font-size: 20px;
            // font-family: PingFang SC;
            font-weight: bold;
            color: #9295a9;
            line-height: 30px;
            text-align: left;
          }

          .inp {
            margin-top: 14px;

            .check_box {
              display: flex;
              flex-direction: column;
              text-align: left;
              font-size: 16px;
              // font-family: PingFang SC;
              font-weight: 500;
              color: #333649;
              // line-height: 18px;
              // justify-content:left;
              // align-content: left;
            }
          }
        }

        .sub_btn {
          // width: 191px;
          width: 100%;
          height: 50px;
          line-height: 50px;
          background: #3051e8;
          border-radius: 20px;
          font-size: 26px;
          // font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
          padding: 0;
        }
      }
    }
  }
}

.h5main {
  min-width: 100%;
  background: #ffffff;

  .htop {
    height: 125px;
  }

  .banner {
    width: 100%;
    font-size: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .simg {
      width: 1000px;
      height: auto;
    }
  }

  .main_box {
    width: 100%;

    .slideshow {
      height: auto;

      .my-swipe {
        width: auto;
        margin: 20px;
      }

      .item {
        width: 100%;
      }

      .pre {
        left: 56px;
        width: 56px;
        height: 56px;
      }

      .next {
        left: calc(100% - 106px);
        width: 56px;
        height: 56px;
      }
    }

    .box_top {
      .left_item {
        .l_title {
          font-size: 32px;
        }
      }
    }

    .box_right {
      background: #ffffff;

      .right_item {
        flex-direction: column;
        height: auto;

        .item_img {
          border-radius: 8px 8px 8px 8px;
          width: 100%;
          height: auto;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .item_con {
          height: auto;

          .con1 {
            font-size: 32px;
            margin: 20px 0;
          }

          .con2 {
            font-size: 26px;
            line-height: 42px;
          }

          .con3 {
            margin: 20px 0;

            .con3_tab {
              width: auto;
              padding: 10px;
              font-size: 24px;
            }
          }

          .con4 {
            font-size: 24px;
          }

          .btn {
            position: relative;
            position: relative;
            margin: 40px auto;
            height: 68px;
            width: 50%;
            font-size: 28px;
          }

          .btn:hover {
            background: #0052da;
            color: #ffffff;
          }
        }
      }
    }

    .page {
      margin-top: 30px;
      margin-bottom: 40px;
      padding: 30px;
      background: #ffffff;

      ::v-deep {

        i,
        li {
          font-size: 32px;
          padding: 0 20px;
        }
      }
    }
  }
}
</style>
